import Ec91appImage from "@/statics/ec91app.jpg";
import EcCyberbizImage from "@/statics/ecCyberbiz.jpg";
import EcFlapsImage from "@/statics/ecFlaps.jpg";
import EcShopifyImage from "@/statics/ecShopify.jpg";
import EcShoplineImage from "@/statics/ecShopline.jpg";

export interface EcommercePlatform {
  /** Harmony's platform setting type, lowercased. */
  type: string;
  name: string;
  imageUrl: string;
}

/**
 * The EC platforms Harmony syncs, in the order MAAC's app market lists them.
 * Names are brand names and stay untranslated.
 */
export const ECOMMERCE_PLATFORMS: Array<EcommercePlatform> = [
  { type: "shopify", name: "Shopify", imageUrl: EcShopifyImage },
  { type: "shopline", name: "SHOPLINE", imageUrl: EcShoplineImage },
  { type: "91app", name: "91APP", imageUrl: Ec91appImage },
  { type: "cyberbiz", name: "CYBERBIZ", imageUrl: EcCyberbizImage },
  { type: "flaps", name: "FLAPS", imageUrl: EcFlapsImage },
];
